import React from 'react';

interface IAccordionContext {
  /** An array containing the current open panel ids */
  openPanelIdsArr?: string[];
  /** The function used to manage the openPanelIdsArr */
  handleSetCurrentOpenPanelsIdsArr?(managedPanelId: string): void;
}

/**
 * Context below is used for connecting Accordion component to AccordionPanels,
 * provides them openPanelIdsArr array that contains panelsIds of open panels.
 */
const AccordionContext = React.createContext<IAccordionContext>({});

export default AccordionContext;
